import Pagination from '@/util/pagination'
import reviewStatuses from '@/util/reviewStatuses'

export default function () {
  return {
    reviews: [],
    reviewStatuses,
    filters: {
      'teacher.email': '',
      'author.email': '',
      featured: false,
    },
    pagination: new Pagination(),
    showReviewDetails: false,
    openReview: {
      id: null,
      content: null,
      author: {},
      teacher: {},
    },
  }
}
